import { Auth0Provider, AppState } from '@auth0/auth0-react';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { applicationDataSelector } from './store/slices/applicationData';

const AuthProvider = ({ children }: any) => {
  const { globalData } = useSelector(applicationDataSelector);

  const navigate = useNavigate();
  // console.log('AuthProvider', { config });

  const onRedirectCallback = (appState?: AppState) => {
    navigate((appState && appState.returnTo) || window.location.pathname);
  };

  useEffect(() => {
   

  }, [globalData]);
 

  return (
    <>
      {globalData && (
        <Auth0Provider
          onRedirectCallback={onRedirectCallback}
          domain={globalData && globalData.auth0DomainName ? globalData && globalData.auth0DomainName : ''}
          clientId={globalData && globalData.auth0ClientId ? globalData.auth0ClientId : ''}
          authorizationParams={{
            redirect_uri: window.location.origin,
          }}
          // useRefreshTokens={true}
          cacheLocation="localstorage"
        
          // screen_hint="signup"
          // scope="openid profile modelcentral api"
        >
          {children}
        </Auth0Provider>
      )}
    </>
  );
};

export default AuthProvider;
